(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientOrderTplSearch', PatientOrderTplSearch);

    PatientOrderTplSearch.$inject = ['$resource'];

    function PatientOrderTplSearch($resource) {
        var resourceUrl =  'api/_search/patient-orders-tpl/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
